import {Component, OnInit} from '@angular/core';

import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import {ReservaService} from '../../../../core/services/reserva.service';
import {NgForOf, NgIf} from '@angular/common';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-calendar',
  imports: [NzBadgeModule, NzCalendarModule, NgForOf, NgIf, NzToolTipModule],
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {
  reservas: any[] = []; // Array para almacenar las reservas
  eventsMap: { [key: string]: { type: string, content: string }[] } = {}; // Mapa de eventos

  constructor(private reservaService: ReservaService) {}

  ngOnInit(): void {
    // Obtén las reservas desde el servicio
    this.reservaService.getReservasForCalendar().subscribe((reservas) => {
      this.reservas = reservas;
      this.populateEventsMap(); // Poblar los eventos en el mapa
    });
  }

  // Función para poblar el mapa de eventos
  populateEventsMap(): void {
    this.eventsMap = {}; // Limpiar el mapa antes de poblarlo

    this.reservas.forEach((reserva) => {
      let fecha = new Date(reserva.fecha); // Convertir la fecha a objeto Date
      fecha.setDate(fecha.getDate() + 1); // Sumamos un día a la fecha

      const fechaKey = `${fecha.getFullYear()}-${fecha.getMonth() + 1}-${fecha.getDate()}`; // Crear la clave 'YYYY-MM-DD'

      // Crear el contenido del evento con el formato hora - campo
      const content = `${reserva.horaInicio} - ${reserva.horaFin} Campo: ${reserva.campo}`;

      // Determinar el tipo según el estado
      const tipo = reserva.estado === "Pagado" ? 'error' : 'success'; // Si estado es 1, tipo es 'error' (rojo), si no es 'success' (verde)

      // Añadir el evento al mapa de eventos por fecha
      if (this.eventsMap[fechaKey]) {
        this.eventsMap[fechaKey].push({ type: tipo, content });
      } else {
        this.eventsMap[fechaKey] = [{ type: tipo, content }];
      }
    });
  }

  // Método que se llama para cada celda del calendario
  getDateEvents(date: Date): { type: string, content: string }[] | null {
    const fechaKey = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    return this.eventsMap[fechaKey] || null;
  }
}

